// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/activestands.less
// module id = 389
// module chunks = 0